/* GharVeda – product page behaviour */
(function () {
  'use strict';
  function money(cents, currency) {
    var v = cents / 100;
    try {
      return new Intl.NumberFormat('en-IN', { style: 'currency', currency: currency || 'INR', minimumFractionDigits: v % 1 === 0 ? 0 : 2, maximumFractionDigits: 2 }).format(v);
    } catch (e) { return v.toFixed(2); }
  }
  function parse(el) { try { return JSON.parse(el.textContent); } catch (e) { return null; } }
  function setCartCount(n) { document.querySelectorAll('[data-gv-cart-count]').forEach(function (el) { el.textContent = n; }); }

  function initProduct(root) {
    if (root.__gvInit) return; root.__gvInit = true;
    var variants = parse(root.querySelector('[data-gv-variants]')) || [];
    var cfg = parse(root.querySelector('[data-gv-config]')) || {};
    var form = root.querySelector('[data-gv-form]');
    if (!form) return;
    var idInput = form.querySelector('[data-gv-variant-id]');
    var qtyInput = form.querySelector('[data-gv-qty-input]');
    var atc = form.querySelector('[data-gv-atc]');
    var atcLabel = form.querySelector('[data-gv-atc-label]');
    var buyNow = form.querySelector('[data-gv-buy-now]');
    var errEl = form.querySelector('[data-gv-error]');
    var slides = [].slice.call(root.querySelectorAll('.gv-gallery__slide'));
    var thumbs = [].slice.call(root.querySelectorAll('[data-gv-thumb]'));
    var defaultLabel = atcLabel ? atcLabel.textContent : 'Add to cart';

    function showSlide(i) {
      slides.forEach(function (s, n) { s.classList.toggle('is-active', n === i); });
      thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === i); });
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { showSlide(parseInt(t.getAttribute('data-gv-thumb'), 10)); }); });

    form.querySelectorAll('[data-gv-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        var v = (parseInt(qtyInput.value, 10) || 1) + parseInt(b.getAttribute('data-gv-qty'), 10);
        qtyInput.value = Math.max(1, v);
      });
    });
    qtyInput && qtyInput.addEventListener('change', function () { qtyInput.value = Math.max(1, parseInt(qtyInput.value, 10) || 1); });

    function applyVariant(v) {
      if (!v) {
        [atc, buyNow].forEach(function (b) { b && (b.disabled = true); });
        if (atcLabel) atcLabel.textContent = 'Unavailable';
        return;
      }
      idInput.value = v.id;
      var now = root.querySelector('[data-gv-price-now]');
      var was = root.querySelector('[data-gv-price-was]');
      if (now) now.textContent = money(v.price, cfg.currency);
      if (was) was.textContent = v.compare_at_price > v.price ? money(v.compare_at_price, cfg.currency) : '';
      [atc, buyNow].forEach(function (b) { b && (b.disabled = !v.available); });
      if (atcLabel) atcLabel.textContent = v.available ? defaultLabel : 'Sold out';
      if (v.featured_media && slides.length) {
        slides.forEach(function (s, n) { if (String(s.getAttribute('data-media-id')) === String(v.featured_media.id)) showSlide(n); });
      }
      try { var url = new URL(window.location.href); url.searchParams.set('variant', v.id); window.history.replaceState({}, '', url.toString()); } catch (e) {}
    }

    var select = form.querySelector('[data-gv-variant-select]');
    if (select) select.addEventListener('change', function () {
      applyVariant(variants.filter(function (v) { return String(v.id) === select.value; })[0]);
    });
    var optionGroups = [].slice.call(form.querySelectorAll('[data-gv-option]'));
    optionGroups.forEach(function (g) {
      g.addEventListener('change', function () {
        var chosen = optionGroups.map(function (grp) { var c = grp.querySelector('input:checked'); return c ? c.value : null; });
        optionGroups.forEach(function (grp, i) { var l = grp.querySelector('[data-gv-option-label]'); if (l && chosen[i]) l.textContent = ' ' + chosen[i]; });
        applyVariant(variants.filter(function (v) { return v.options.every(function (o, i) { return o === chosen[i]; }); })[0]);
      });
    });

    function showError(msg) { if (!errEl) return; errEl.textContent = msg || ''; errEl.hidden = !msg; }
    function addToCart() {
      showError('');
      return fetch(cfg.add_url + '.js', { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' }, body: new FormData(form) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add to cart'); return j; }); });
    }
    function refreshCount() {
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { setCartCount(c.item_count); });
    }
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (atc.disabled) return;
      atc.disabled = true;
      addToCart().then(refreshCount).then(function () {
        if (atcLabel) atcLabel.textContent = cfg.added || 'Added';
        setTimeout(function () { atc.disabled = false; if (atcLabel) atcLabel.textContent = defaultLabel; }, 1600);
      }).catch(function (err) { showError(err.message); atc.disabled = false; });
    });
    buyNow && buyNow.addEventListener('click', function () {
      if (buyNow.disabled) return;
      buyNow.disabled = true;
      addToCart().then(function () { window.location.href = '/checkout'; }).catch(function (err) { showError(err.message); buyNow.disabled = false; });
    });
  }
  function boot() { document.querySelectorAll('[data-gv-product]').forEach(initProduct); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();